document.addEventListener("DOMContentLoaded", function () {
  var keepMenuOpen = function keepMenuOpen() {
    if (!document.body.classList.contains("show-sidebar-main")) {
      document.body.classList.add("show-sidebar-main");
      document.body.classList.add("active");
      document.querySelector(".left-side").classList.remove("border-right");
      console.log("Menu opened and gasp running");
    }
  };
  var keepMenuClosed = function keepMenuClosed() {
    if (document.body.classList.contains("show-sidebar-main")) {
      document.body.classList.remove("show-sidebar-main");
      document.body.classList.remove("active");
      document.querySelector(".left-side").style.background = "transparent";
      document.querySelector(".left-side").classList.add("border-right");
      var menuOverlay = document.querySelector(".menu-popup-background");
      if (menuOverlay) {
        menuOverlay.remove();
      }
      console.log("Menu closed");
    }
  };
  const mobileMenu = document.querySelector(".js-menu-toggle-home-mobile");
  if (mobileMenu != null) {
    mobileMenu.onclick = function (e) {
      keepMenuOpen();
    };
  }
  window.addEventListener("click", function (e) {
    var target = e.target;
    if (target.closest(".js-menu-toggle-home-mobile") == null && target.closest("#aside_main") == null) {
      closeSidebar(e);
    }
  });
  var closeSidebar = function closeSidebar(e) {
    passive: true;
    var container = document.querySelector("#aside_main");
    var $body = document.body;
    if (!(container.classList[0] === e.target.classList[0]) && container.querySelector(e.target.classList[0]) == null) {
      if ($body.classList.contains("show-sidebar-main")) {
        keepMenuClosed();
        console.log(e.target);
      }
    }
  };
  var closeBtn = document.querySelector(".js-close-menu");
  if (closeBtn != null) {
    closeBtn.onclick = function (e) {
      keepMenuClosed();
      console.log("test");
    };
  }
});

//SIDEBAR MENU DESKTOP
document.addEventListener("DOMContentLoaded", function () {
  desktopSidebarMenu();
});
document.addEventListener("shopify:section:load", function () {
  desktopSidebarMenu();
});
document.addEventListener("shopify:section:unload", function () {
  desktopSidebarMenu();
});
document.addEventListener("shopify:section:reorder", function () {
  desktopSidebarMenu();
});

function desktopSidebarMenu() {
  // Mobile menu parent items acc
  var accParent = document.querySelectorAll(".menu-parent-menu-item-inner .collapsible");
  if (accParent.length > 0) {
    accParent.forEach(function (acc) {
      acc.onclick = function (e) {
        e.preventDefault();
      };
    });
  }
  // Desktop menu
  var sidebarMenuDefaultHide = document.body;
  if (Shopify.designMode != true) {
    if (sidebarMenuDefaultHide != null) {
      if (document.querySelector(".sidebar-menu-show-default-false") != null) {
        sidebarMenuDefaultHide.classList.remove("active-menu");
        sidebarMenuDefaultHide.classList.remove("sidebar-menu-hide-default");
      }
    }
  }
  var menuToggle = document.querySelector(".js-menu");
  if (menuToggle != null) {
    var body = document.body;
    var floating = document.querySelector(".desktop-sidebar-menu-type-floating");
    if (floating != null) {
      body.classList.remove("active-menu");
      body.classList.add("floating-menu-enabled");
    }
    if (Shopify.designMode == true) {
      if (body != null) {
        if (document.querySelector(".sidebar-menu-show-default-true") != null) {
          body.classList.add("active-menu");
          body.classList.remove("sidebar-menu-hide-default");
        }
        if (document.querySelector(".sidebar-menu-show-default-false") != null) {
          body.classList.remove("active-menu");
          body.classList.add("sidebar-menu-hide-default");
        }
        var floating = document.querySelector(".desktop-sidebar-menu-type-floating");
        if (floating != null) {
          body.classList.remove("active-menu");
          body.classList.add("floating-menu-enabled");
        }
      }
    }
    menuToggle.onclick = function (e) {
      e.preventDefault();
      var sidebarMenuDefaultHide = document.querySelector(
        ".sidebar-menu-hide-default"
      );
      if (sidebarMenuDefaultHide != null) {
        sidebarMenuDefaultHide.classList.remove("sidebar-menu-hide-default");
      }
      if (body.classList.contains("active-menu")) {
        body.classList.remove("active-menu");
        //localStorage.setItem("menuActive", false);
        var allItems = document.querySelectorAll(
          ".back-to-parent-menu,.back-to-child-menu,.desktop-sidebar-menu-parent-items li a, .desktop-sidebar-menu-parent-items .parent-menu-item .next-item-icon"
        );
        if (allItems.length > 0) {
          allItems.forEach(function (aitem, i) {
            aitem.setAttribute("tabindex", "-1");
          });
        }
      } else {
        body.classList.add("active-menu");
        localStorage.setItem("menuScrollOffset", window.scrollY);
        //localStorage.setItem("menuActive", true);
        var allParentItems = document.querySelectorAll(
          ".desktop-sidebar-menu-parent-items .parent-menu-item > a,.desktop-sidebar-menu-parent-items .parent-menu-item > .next-item-icon"
        );
        if (allParentItems.length > 0) {
          allParentItems.forEach(function (item, i) {
            item.setAttribute("tabindex", 0);
          });
        }
      }
    };
  }
  var allItems = document.querySelectorAll(".back-to-parent-menu,.back-to-child-menu,.desktop-sidebar-menu-parent-items li a, .desktop-sidebar-menu-parent-items .parent-menu-item .next-item-icon");
  var nextItems = document.querySelectorAll(".next-item-icon");
  if (nextItems.length > 0) {
    nextItems.forEach(function (item) {
      item.onclick = function (e) {
        if (allItems.length > 0) {
          allItems.forEach(function (aitem, i) {
            aitem.setAttribute("tabindex", "-1");
          });
        }
        var nextMenu = item.closest("li").querySelector(".desktop-sidebar-menu-next");
        if (nextMenu != null) {
          // e.preventDefault();
          nextMenu.style.transform = "translateX(0%)";
          item.closest("li").classList.add("active-menu");

          var allChildItems = nextMenu.querySelectorAll(".back-to-parent-menu,.child-menu-item > a,.child-menu-item > .next-item-icon");
          if (allChildItems.length == 0) {
            allChildItems = nextMenu.querySelectorAll(".back-to-child-menu,.grand-menu-item > a,.grand-menu-item > .next-item-icon");
          }
          setTimeout(function () {
            if (allChildItems.length > 0) {
              allChildItems.forEach(function (item, i) {
                item.setAttribute("tabindex", 0);
                if (i == 0) {
                  item.focus();
                }
              });
            }
            //console.log('allChildItems',allChildItems);
          }, 10);
        }
      };
    });
  }
  var ItemsBack = document.querySelectorAll(".back-to-previous-menu");
  if (ItemsBack.length > 0) {
    ItemsBack.forEach(function (item) {
      item.onclick = function () {
        if (allItems.length > 0) {
          allItems.forEach(function (aitem, i) {
            aitem.setAttribute("tabindex", "-1");
          });
        }
        item.setAttribute("tabindex", "-1");
        if (item.closest("li").classList.contains("active-menu")) {
          item.closest(".desktop-sidebar-menu-next").style.removeProperty("transform");
          var currentMenu = item.closest(".desktop-sidebar-menu-next");
          var allChildItems = currentMenu.querySelectorAll(".back-to-parent-menu,.child-menu-item > a,.child-menu-item > .next-item-icon");
          if (allChildItems.length == 0) {
            allChildItems = currentMenu.querySelectorAll(".back-to-child-menu,.grand-menu-item > a,.grand-menu-item > .next-item-icon");
          }
          setTimeout(function () {
            if (allChildItems.length > 0) {
              allChildItems.forEach(function (item, i) {
                item.setAttribute("tabindex", "-1");
              });
            }
            console.log("allChildItems current", allChildItems);
          }, 5);

          if (item.closest(".back-to-child-menu") != null) {
            var childBack = item.closest(".desktop-sidebar-menu-child-items");
            if (childBack != null) {
              var allChildItems = childBack.querySelectorAll(".back-to-parent-menu,.child-menu-item > a,.child-menu-item > .next-item-icon");
              setTimeout(function () {
                if (allChildItems.length > 0) {
                  allChildItems.forEach(function (item, i) {
                    item.setAttribute("tabindex", 0);
                  });
                }
              }, 10);
            }
          } else if (item.classList.contains(".back-to-parent-menu") != null) {
            var prentBack = item.closest(".desktop-sidebar-menu-parent-items");
            if (prentBack != null) {
              var allParentItems = prentBack.querySelectorAll(".parent-menu-item > a,.parent-menu-item > .next-item-icon");
              setTimeout(function () {
                if (allParentItems.length > 0) {
                  allParentItems.forEach(function (item, i) {
                    item.setAttribute("tabindex", 0);
                  });
                }
              }, 10);
              console.log("allParentItems", allParentItems);
            }
          }
          //console.log(item.closest('.desktop-sidebar-menu-child-items'));
        }
      };
    });
  }
}
var floatingBtn = document.querySelector(".floating-menu-button-wrapper a");
if (floatingBtn != null) {
  var body = document.body;
  window.addEventListener("scroll", function () {
    if (body.classList.contains("active-menu")) {
      var pageOffset = localStorage.getItem("menuScrollOffset");
      var pageOffsetCurrent = window.scrollY;
      var diff = pageOffsetCurrent - pageOffset;
      if (Math.abs(diff) > 300) {
        body.classList.remove("active-menu");
      }
    }
  });
}
// accessibility code
document.addEventListener("keydown", function (event) {
  var activeElement = document.activeElement;
  setTimeout(function () {
    var allItems = document.querySelectorAll(".desktop-sidebar-menu-parent-items li a, .desktop-sidebar-menu-parent-items .parent-menu-item .next-item-icon");
    var allIParentItems = document.querySelectorAll(".desktop-sidebar-menu-parent-items .parent-menu-item > a, .desktop-sidebar-menu-parent-items .parent-menu-item > .next-item-icon");
    var allINextIconItems = document.querySelectorAll(".desktop-sidebar-menu-parent-items .parent-menu-item .next-item-icon");
    var menuFirstItem = document.querySelector(".desktop-sidebar-menu-parent-items > li:first-child > a");
    if (allItems != null) {
      if (event.key === "Enter") {
        var nextItems = document.querySelectorAll(".back-to-previous-menu");
        if (nextItems.length > 0) {
          nextItems.forEach(function (item) {
            if (activeElement == item) {
              item.click();
            }
          });
        }
        var nextItems = document.querySelectorAll(".next-item-icon");
        if (nextItems.length > 0) {
          nextItems.forEach(function (item) {
            if (activeElement == item) {
              item.click();
            }
          });
        }
      }
      if (event.key === "Tab" && !event.shiftKey) {
          var activeSubMenu = document.querySelector('.back-to-previous-menu[tabindex="0"]');
          var activeSubMenuLastItem = document.querySelector('.back-to-previous-menu[tabindex="0"] + .sub-menu > li:last-child > a');
          if(activeSubMenu != null && activeSubMenuLastItem != null){
            if(activeElement == activeSubMenuLastItem){
              activeSubMenu.click();
              setTimeout(function () {
                var activeSubMenu = document.querySelector('.back-to-previous-menu[tabindex="0"]');
                if(activeSubMenu != null){
                  activeSubMenu.click();
                }
              },100);
          }
        }
      }
    }
  }, 100);
});
// header search modal
document.addEventListener("DOMContentLoaded", function () {
  var modal = document.querySelector(".js-search-modal");
  if (modal != null) {
    setTimeout(function () {
      modal.classList.remove('d-none');
    }, 2000);
    var btns = document.querySelectorAll(".js-search-modal-link");
    var btnCloseModal = document.querySelector(".js-search-close");
    var closeBtns = document.querySelectorAll(".search-modal-close,.js-search-close");
    if (btns.length > 0) {
      btns.forEach(function (btn) {
        btn.onclick = function (e) {
          e.preventDefault();
          document.querySelector('html').classList.add('overflow-hidden');
          document.body.classList.add("show-search-modal");
          var form = modal.querySelector(".header-search");
          if (form != null) {
            form.setAttribute("tabindex", 0);
            var button = form.querySelector('input[name="q"]');
            if (button != null) {
              setTimeout(function () {
                button.focus();
              }, 100);
            }
          }
        };
      });
    }
    if (closeBtns.length > 0) {
      closeBtns.forEach(function (close) {
        close.onclick = function (e) {
          e.preventDefault();
          console.log('closed search');
          document.body.classList.remove("show-search-modal");
           document.querySelector('html').classList.remove('overflow-hidden');
        };
      });
    }
    window.onclick = function (event) {
      if (event.target == document.body) {
        document.body.classList.remove("show-search-modal");
        document.querySelector('html').classList.remove('overflow-hidden');
      }
    };
  }
});
